import { CheckCircle2, LoaderCircle } from 'lucide-react';

import { useAcknowledgeParentConnect } from '../../api/queries';

interface ParentConnectAcknowledgementProps {
  sessionId: string;
  startTime: number;
}

export const ParentConnectAcknowledgement = ({
  sessionId,
  startTime,
}: ParentConnectAcknowledgementProps) => {
  const acknowledgement = useAcknowledgeParentConnect();
  if (acknowledgement.isSuccess) {
    return (
      <span className="flex items-center gap-2 whitespace-nowrap text-underwater-fern-green rounded-full bg-white px-4 py-2">
        <CheckCircle2 className="h-4 w-4" />
        Acknowledged
      </span>
    );
  }
  return (
    <div className="flex flex-col items-end gap-1 max-w-64">
      <button
        type="button"
        disabled={acknowledgement.isPending}
        aria-busy={acknowledgement.isPending}
        className="flex items-center gap-2 whitespace-nowrap rounded-full border border-blue-chaos bg-white px-3 py-1.5 md:px-4 md:py-2 font-semibold text-blue-chaos hover:bg-blue-chaos-light-cardbg disabled:opacity-60"
        onClick={() =>
          acknowledgement.mutate({
            session_id: sessionId,
            start_time: startTime,
          })
        }
      >
        {acknowledgement.isPending ? (
          <LoaderCircle className="h-4 w-4 animate-spin" />
        ) : (
          <CheckCircle2 className="h-4 w-4" />
        )}
        Acknowledge
      </button>
      {acknowledgement.isError ? (
        <span role="alert" className="text-xs text-fusion-red-dark">
          Unable to acknowledge. Please retry.
        </span>
      ) : null}
    </div>
  );
};
